













import Vue from 'vue'
import { Component } from 'vue-property-decorator';

@Component
({
    mounted: function() {
         //this.$store.commit('INBOUND_CALL_CHANGE',{});
        // this.$store.commit('OUTBOUND_CALL_CHANGE',{});
     }
})
export default class CallDirectionFilterSchedul extends Vue{
    get inboundChecked() {
        return this.$store.state.reports.filters.inboundChecked_schedule;
    }

    get outboundChecked() {
        return this.$store.state.reports.filters.outboundChecked_Schedule;
    }

    inboundCallCheckedChanged(newVal: any) {
        this.$store.commit('INBOUND_CALL_CHANGE_SCHEDULE', {
            newVal
        });
    }

    outboundCallCheckedChanged(newVal: any) {
        this.$store.commit('OUTBOUND_CALL_CHANGE_SCHEDULE', {
            newVal
        });
    }
}
